import {
  Box,
  Flex,
  Grid,
  Skeleton,
  SkeletonText,
  Stack,
} from '@chakra-ui/react';

export default function SubCategorySkeleton() {
  return (
    <Box p={8}>
      <Stack spacing={4}>
        <Skeleton height="30px" width="300px" />
        <SkeletonText noOfLines={1} width="350px" spacing="4" />
      </Stack>

      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
        gap={6}
        mt={8}
      >
        {Array.from({ length: 7 }).map((_, i) => (
          <Box key={i} p={4} boxShadow="sm" borderRadius="md" borderWidth="1px">
            <Skeleton height="20px" width="60%" mb={2} />
            <SkeletonText noOfLines={2} spacing="3" />
          </Box>
        ))}
      </Grid>

      <Flex justify="space-between" mt={10}>
        <Skeleton height="40px" width="80px" borderRadius="md" />
        <Skeleton height="40px" width="100px" borderRadius="md" />
      </Flex>
    </Box>
  );
}
